import { ToastNotification, useToast } from '@icanbwell/ui-toolkit'
import { useTranslation } from 'react-i18next'

export type notificationOptions = Omit<ToastNotification, 'title'> & {
  title?: string
}

export const useNotifications = () => {
  const { t } = useTranslation('shared')
  const toast = useToast()

  const showToast = (props: notificationOptions) => {
    const { message, variant, title = '', horizontal = 'right', deleteIcon = true, vertical = 'bottom' } = props
    return toast({
      title: title || variant === 'error' ? t('error') : t('success'),
      message,
      variant,
      horizontal,
      deleteIcon,
      vertical,
    })
  }
  return showToast
}
